module.exports = __webpack_public_path__ + "static/Canela-LightItalic-0b42c14f1ffeca0cce6acdb08f8eacf6.otf";